import Vue from "vue";

Vue.component(
  "luxury-hotels-map-component",
  require("./components/luxury_hotels/GoogleMapComponent.vue").default
);

const app = new Vue({
  el: "#vueHotelMap",
});
